import {
  CUSTOM_PARAMS_FETCH,
  CUSTOM_PARAMS_SET_STATE,
  CUSTOM_PARAMS_UPDATE_STATE,
  CUSTOM_PARAMS_FAILED,
  CUSTOM_PARAM_CHANGED
} from '../constants/actionTypes';

export function fetchCustomParams() {
  return {
    type: CUSTOM_PARAMS_FETCH
  };
}

export function setCustomParamsState(state) {
  return {
    type: CUSTOM_PARAMS_SET_STATE,
    payload: state,
  };
}

export function updateCustomParamsState(state) {
  return {
    type: CUSTOM_PARAMS_UPDATE_STATE,
    payload: state
  };
}

export function setCustomParamsError(error) {
  return {
    type: CUSTOM_PARAMS_FAILED,
    payload: error
  };
}

export function customParamChanged(customParam, newCustomParamValue) {
  return {
    type: CUSTOM_PARAM_CHANGED,
    payload: Object.assign({}, customParam, { value: newCustomParamValue }),
  };
}

